export default "__VITE_ASSET__2ffc0773__"